import DeviceActivation from '@/views/DeviceActivation.vue';
import Firmwares from '@/views/Firmwares.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Vue from 'vue';
import Router from 'vue-router';
import Session from './plugins/session';

Vue.use(Router);

/**
 * Router
 */
const router: Router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        layout: 'connected-layout',
        title: 'home',
      },
    },
    {
      path: '/device-activation',
      name: 'device-activation',
      component: DeviceActivation,
      meta: {
        layout: 'connected-layout',
        title: 'device-activation',
      },
    },
    {
      path: '/firmwares',
      name: 'firmwares',
      component: Firmwares,
      meta: {
        layout: 'connected-layout',
        title: 'firmwares',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

/**
 * Before each route
 */
router.beforeEach((to, from, next) => {
  // Session plugin
  const session: Session = Vue.$session;

  // List of public pages
  const publicPages = ['/login'];
  const authRequired: boolean = !publicPages.includes(to.path);

  // Check if user authticated
  const isAuthenticated = session.isAuthenticated();

  if (authRequired && !isAuthenticated) {
    // If unauthenticated && authentication required, goto /login
    return next('/login');
  }

  // Goto next route
  next();
});

export default router;
